import React, { useEffect, useState } from 'react'
import './style.css'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setCountry } from '../../redux/slices/countrySlice'
import { megaMenuUpdatedContent } from '../../data/menu-data'
import Button from '../CtaButton'
import OurLocations from '../ourlocations/OurLocations'
import FloatingBar from '../floating-bar/FloatingBar'
import { toUpper } from '../../utils/case'
import i18n from '../../18n'

const MegaMenu = () => {

    const [showBarsMenu, setShowBarsMenu] = useState(false)
    const [showMobileMenu, setShowMobileMenu] = useState(false)
    const [mobileCountryDropdown, setMobileCountryDropdown] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1201);

    // CLOSE MEAGA MENU WHEN THE SAME PAGE IS ACTIVE
    const [forceCloseMenu, setForceCloseMenu] = useState(false);
    const handleEngagementClick = (e, link) => {
        if (location.pathname === link) {
            e.preventDefault();

            // Force close menu for 300ms
            setForceCloseMenu(true);
            setTimeout(() => setForceCloseMenu(false), 300);
        }
    };
    // CLOSE MEAGA MENU WHEN THE SAME PAGE IS ACTIVE

    const mobileCountryDropdownToggle = (dropdownId) => {
        setMobileCountryDropdown((prev) =>
            prev === dropdownId ? null : dropdownId
        );
    };
    const mobileCountryDropdownClose = () => {
        setMobileCountryDropdown(null);
    };

    // LOGO REDIRECTION
    const location = useLocation()
    const dispatch = useDispatch()
    const allowedCountries = ["us", "ksa", "au", "uae"];
    const currentCountryFromUrl = allowedCountries.find((country) =>
        location.pathname.includes(`/${country}`)
    );
    const country = useSelector((state) => state.country.name);
    const currentCountry = currentCountryFromUrl
        ? currentCountryFromUrl
        : country;
    console.log("country from redux", currentCountry);
    useEffect(() => {
        if (currentCountryFromUrl) {
            console.log(`check ${currentCountryFromUrl}`);
            dispatch(setCountry(country));
        }
    }, []);
    // LOGO REDIRECTION

    // Define all home page paths
    const homePaths = ["/", "/us", "/ksa", "/au", "/uae"];
    // Check if current path is in home paths
    const isHomePage = homePaths.includes(location.pathname);


    //
    // useEffect(() => {
    //     // Force close hover menu every time route changes
    //     setForceCloseMenu(true);

    //     // Reset after 200ms to restore normal hover behavior
    //     const timer = setTimeout(() => setForceCloseMenu(false), 200);

    //     return () => clearTimeout(timer);
    // }, [location.pathname]);

    useEffect(() => {
        // close mobile menu
        setShowMobileMenu(false);

        // close desktop hover menu
        setForceCloseMenu(true);
        const timer = setTimeout(() => setForceCloseMenu(false), 300);

        return () => clearTimeout(timer);
    }, [location.pathname]);


    return (
        <>
            <nav className={`navbar navbar-expand-lg bg-body-tertiary mega-menu-main-box ${isHomePage ? "transparent-header" : ""}`}>
                <div className="container">
                    {/* <Link className="navbar-brand"
                        to={`/${currentCountry && currentCountry !== "PK" ? currentCountry : ""
                            }`}
                    > */}
                    <Link className="navbar-brand"
                        to={`/`}
                    >
                        <img
                            width={210}
                            height={60}
                            src="/images/logo.svg"
                            className="green-logo"
                            alt="Bitsclan IT Solutions"
                        />
                    </Link>

                    <div className='d-flex align-items-center'>
                        {/* <ul className='mobile-country-dropdown mb-0 me-3'>
                            <li
                                className="nav-item"
                                onMouseEnter={() =>
                                    !isMobile && mobileCountryDropdownToggle("dropdown4")
                                }
                                onMouseLeave={() => !isMobile && mobileCountryDropdownClose()}
                            >
                                <a
                                    className="dropdown-toggle nav-link"
                                    href="javascript:void(0)"
                                    role="button"
                                    aria-expanded={
                                        mobileCountryDropdown === "dropdown4" ? "true" : "false"
                                    }
                                // onClick={() =>
                                //     isMobile && mobileCountryDropdownToggle("dropdown4")
                                // }
                                >
                                    <i className="fa-globe fa-solid"></i>{" "}
                                    {currentCountry && toUpper(currentCountry)}{" "}
                                    <i
                                        className={`fa-solid fa-arrow-down ${mobileCountryDropdown === "dropdown4" ? "up-arrow" : ""
                                            }`}
                                    ></i>
                                </a>
                                <ul
                                    className={`dropdown-menu ${mobileCountryDropdown === "dropdown4" ? "show" : ""
                                        } country-dropdown`}
                                >
                                    {allowedCountries.map((country) => (
                                        <li key={country}>
                                            <Link
                                                className="country-url"
                                                to={`/${country}`}
                                                onClick={() => {
                                                    dispatch(setCountry(country));

                                                    // Change language based on country
                                                    if (country === "ksa") {
                                                        i18n.changeLanguage("ar");
                                                    } else {
                                                        i18n.changeLanguage("en");
                                                    }
                                                }}
                                            >
                                                <p
                                                    className="my-0"
                                                    style={{ textTransform: "uppercase" }}
                                                >
                                                    {toUpper(country)}
                                                </p>{" "}
                                                <i
                                                    className={`fa-solid ${document.dir === "rtl"
                                                        ? "fa-arrow-left"
                                                        : "fa-arrow-right"
                                                        }`}
                                                ></i>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        </ul> */}
                        <button className="navbar-toggler" onClick={() => setShowMobileMenu(prev => !prev)} type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            {/* <span className="navbar-toggler-icon" /> */}
                            <i class="fa-solid fa-bars-staggered"></i>
                        </button>
                    </div>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0 mega-menu-links-box">
                            {/* <li className="nav-item">
                                <a className="nav-link menu-dark-bg-link" aria-current="page" href="#">Services</a>
                                <div className="mega-menu-box"></div>
                            </li> */}

                            {/* SERVICES */}
                            <li className="nav-item mega-menu-links-list mega-menu-main-nav-text">
                                {/* menu-dark-bg-link */}
                                <div className="mege-menu-main-links">
                                    <span className="mega-menu-links">{megaMenuUpdatedContent?.menuServices?.mainNavHeading}</span>
                                    <i className="fa-solid fa-angle-down"></i>
                                </div>
                                <div className="mega-menu-box menu-right-blue-bg" style={{ display: forceCloseMenu ? "none" : undefined }}>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="mega-menu-content menu-left-green-box">
                                                    <div className="mega-column">
                                                        <h2 className='menu-short-top-heading'>{megaMenuUpdatedContent?.menuServices?.aiPagesList?.shortHeading}</h2>
                                                        <h4 className="mega-menu-main-heading green-box-heading">{megaMenuUpdatedContent?.menuServices?.aiPagesList?.mainHeading}</h4>
                                                        <ul className='mega-menu-main-list'>
                                                            {megaMenuUpdatedContent?.menuServices?.aiPagesList?.aiList?.map((list, index) => {
                                                                return <li className='menu-light-link' key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                            })}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="mega-menu-content">
                                                                <div className="mega-column">
                                                                    <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuServices?.technologies?.mainHeading}</h4>
                                                                    <ul className='mega-menu-main-list'>
                                                                        {megaMenuUpdatedContent?.menuServices?.technologies?.pageList?.map((list, index) => {
                                                                            return <li key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="mega-menu-content">
                                                                <div className="mega-column">
                                                                    <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuServices?.softwareDevelopment?.mainHeading}</h4>
                                                                    <ul className='mega-menu-main-list'>
                                                                        {megaMenuUpdatedContent?.menuServices?.softwareDevelopment?.pageList?.map((list, index) => {
                                                                            return <li key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="mega-menu-content">
                                                                <div className="mega-column">
                                                                    <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuServices?.engagementModels?.mainHeading}</h4>
                                                                    <ul className='mega-menu-main-list'>
                                                                        {megaMenuUpdatedContent?.menuServices?.engagementModels?.pageList?.map((list, index) => {
                                                                            return <li key={index}><Link to={list?.link} className="mega-link" onClick={(e) => handleEngagementClick(e, list?.link)}>{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="mega-menu-content">
                                                                <div className="mega-column">
                                                                    <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuServices?.MenuIndustries?.mainHeading}</h4>
                                                                    <ul className='mega-menu-main-list'>
                                                                        {megaMenuUpdatedContent?.menuServices?.MenuIndustries?.pageList?.map((list, index) => {
                                                                            return <li key={index}><Link to={`/industries${list?.link}`} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="mega-menu-content mega-menu-solution-box">
                                                    <div className="mega-column">
                                                        <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuServices?.menuSolution?.mainHeading}</h4>
                                                        <ul className='mega-menu-main-list'>
                                                            {megaMenuUpdatedContent?.menuServices?.menuSolution?.pageList?.map((list, index) => {
                                                                return <li key={index}><Link to={list?.link} target={list?.target === 'blank' ? '_blank' : '_self'} className="mega-link text-white">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                            })}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li className="nav-item mega-menu-main-nav-text">
                                <Link to='/case-studies' className="nav-link mega-menu-links">{megaMenuUpdatedContent?.caseStudiesHeading}</Link>
                            </li>

                            {/* ENGENIERS */}
                            <li className="nav-item mega-menu-links-list mega-menu-main-nav-text">
                                <div className="mege-menu-main-links">
                                    <span className="mega-menu-links">{megaMenuUpdatedContent?.menuEngeniers?.mainNavHeading}</span>
                                    <i className="fa-solid fa-angle-down"></i>
                                </div>
                                <div className="mega-menu-box" style={{ display: forceCloseMenu ? "none" : undefined }}>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="mega-menu-content menu-left-green-box">
                                                    <div className="mega-column">
                                                        <h4 className="mega-menu-main-heading green-box-heading">{megaMenuUpdatedContent?.menuEngeniers?.aiEngeniersList?.mainHeading}</h4>
                                                        <ul className='mega-menu-main-list'>
                                                            {megaMenuUpdatedContent?.menuEngeniers?.aiEngeniersList?.pageList?.map((list, index) => {
                                                                return <li className='menu-light-link' key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                            })}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="mega-menu-content">
                                                    <div className="mega-column">
                                                        <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuEngeniers?.mernEngeniersList?.mainHeading}</h4>
                                                        <ul className='mega-menu-main-list'>
                                                            {megaMenuUpdatedContent?.menuEngeniers?.mernEngeniersList?.pageList?.map((list, index) => {
                                                                return <li key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                            })}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="mega-menu-content">
                                                    <div className="mega-column">
                                                        <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuEngeniers?.mobileEngeniersList?.mainHeading}</h4>
                                                        <ul className='mega-menu-main-list'>
                                                            {megaMenuUpdatedContent?.menuEngeniers?.mobileEngeniersList?.pageList?.map((list, index) => {
                                                                return <li key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                            })}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="mega-menu-content">
                                                    <div className="mega-column">
                                                        <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuEngeniers?.webApplicationsEngeniersList?.mainHeading}</h4>
                                                        <ul className='mega-menu-main-list'>
                                                            {megaMenuUpdatedContent?.menuEngeniers?.webApplicationsEngeniersList?.pageList?.map((list, index) => {
                                                                return <li key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                            })}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li className="nav-item mega-menu-main-nav-text ms-2">
                                <Button text="Book a meeting" newTab hideIcon={true} link='https://calendly.com/bitsclan-it/30min' />
                            </li>

                            {/* <li
                                className="nav-item"
                                onMouseEnter={() =>
                                    !isMobile && mobileCountryDropdownToggle("dropdown4")
                                }
                                onMouseLeave={() => !isMobile && mobileCountryDropdownClose()}
                            >
                                <a
                                    className="dropdown-toggle nav-link"
                                    href="javascript:void(0)"
                                    role="button"
                                    aria-expanded={
                                        mobileCountryDropdown === "dropdown4" ? "true" : "false"
                                    }
                                // onClick={() =>
                                //     isMobile && mobileCountryDropdownToggle("dropdown4")
                                // }
                                >
                                    <i className="fa-globe fa-solid"></i>{" "}
                                    {currentCountry && toUpper(currentCountry)}{" "}
                                    <i
                                        className={`fa-solid fa-arrow-down ${mobileCountryDropdown === "dropdown4" ? "up-arrow" : ""
                                            }`}
                                    ></i>
                                </a>
                                <ul
                                    className={`dropdown-menu ${mobileCountryDropdown === "dropdown4" ? "show" : ""
                                        } country-dropdown`}
                                >
                                    {allowedCountries.map((country) => (
                                        <li key={country}>
                                            <Link
                                                className="country-url"
                                                to={`/${country}`}
                                                onClick={() => {
                                                    dispatch(setCountry(country));

                                                    // Change language based on country
                                                    if (country === "ksa") {
                                                        i18n.changeLanguage("ar");
                                                    } else {
                                                        i18n.changeLanguage("en");
                                                    }
                                                }}
                                            >
                                                <p
                                                    className="my-0"
                                                    style={{ textTransform: "uppercase" }}
                                                >
                                                    {toUpper(country)}
                                                </p>{" "}
                                                <i
                                                    className={`fa-solid ${document.dir === "rtl"
                                                        ? "fa-arrow-left"
                                                        : "fa-arrow-right"
                                                        }`}
                                                ></i>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </li> */}

                            <li className="nav-item mega-menu-main-nav-text">
                                {/* <div className="mega-menu-bars-box-main"> </div>*/}
                                <span className='mega-menu-bars' onClick={() => setShowBarsMenu(prev => !prev)}><i className="fa-solid fa-bars-staggered"></i></span>

                                {showBarsMenu && <div className="mega-menu-bars-box">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="cross-icon-main" onClick={() => setShowBarsMenu(prev => !prev)}>
                                                    <i className="fa-solid fa-xmark"></i>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="mega-menu-bars-box-content container">
                                                    <ul className='row'>
                                                        {megaMenuUpdatedContent?.menuBarBox?.pageList?.map((list, index) => {
                                                            return <li className='mega-menu-bar-box-links col-md-4' key={index}>
                                                                <img src="/favicon.ico" alt="Mouse Logo" width={30} /> <Link to={list?.link}>{list?.text}</Link>
                                                            </li>
                                                        })}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <OurLocations />

                                        <FloatingBar showAlways={true} />
                                    </div>
                                </div>}
                            </li>
                        </ul>
                    </div>
                </div>

                {/* MOBILE MEGA MENU */}
                <div className={`mobile-mega-menu-main-box ${showMobileMenu ? "mobile-menu-open" : ""}`} style={{ display: forceCloseMenu ? "none" : undefined }}>
                    <div className="container">
                        <div className="row align-items-center mb-4">
                            <div className="col-10">
                                <Link className="navbar-brand" to={`/${currentCountry && currentCountry !== "PK" ? currentCountry : ""}`}>
                                    <img
                                        width={170}
                                        height={60}
                                        src="/images/logo.svg"
                                        className="green-logo"
                                        alt="Bitsclan IT Solutions"
                                    />
                                </Link>
                            </div>

                            <div className="col-2">
                                <div className="mobile-menu-close-button" onClick={() => setShowMobileMenu(prev => !prev)}><i class="fa-solid fa-xmark"></i></div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="accordion accordion-flush" id="accordionFlushExample">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button mobile-mega-menu-link collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                                {megaMenuUpdatedContent?.menuServices?.mainNavHeading}
                                            </button>
                                        </h2>
                                        <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                            <div className="accordion-body">
                                                <div className="container">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="mega-menu-content">
                                                                <div className="mega-column">
                                                                    <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuServices?.aiPagesList?.mainHeading}</h4>
                                                                    <ul className='mega-menu-main-list'>
                                                                        {megaMenuUpdatedContent?.menuServices?.aiPagesList?.aiList?.map((list, index) => {
                                                                            return <li className='' key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="mega-menu-content">
                                                                <div className="mega-column">
                                                                    <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuServices?.technologies?.mainHeading}</h4>
                                                                    <ul className='mega-menu-main-list'>
                                                                        {megaMenuUpdatedContent?.menuServices?.technologies?.pageList?.map((list, index) => {
                                                                            return <li key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="mega-menu-content">
                                                                <div className="mega-column">
                                                                    <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuServices?.softwareDevelopment?.mainHeading}</h4>
                                                                    <ul className='mega-menu-main-list'>
                                                                        {megaMenuUpdatedContent?.menuServices?.softwareDevelopment?.pageList?.map((list, index) => {
                                                                            return <li key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="mega-menu-content">
                                                                <div className="mega-column">
                                                                    <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuServices?.engagementModels?.mainHeading}</h4>
                                                                    <ul className='mega-menu-main-list'>
                                                                        {megaMenuUpdatedContent?.menuServices?.engagementModels?.pageList?.map((list, index) => {
                                                                            return <li key={index}><Link to={list?.link} className="mega-link" onClick={(e) => handleEngagementClick(e, list?.link)} >{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="mega-menu-content">
                                                                <div className="mega-column">
                                                                    <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuServices?.MenuIndustries?.mainHeading}</h4>
                                                                    <ul className='mega-menu-main-list'>
                                                                        {megaMenuUpdatedContent?.menuServices?.MenuIndustries?.pageList?.map((list, index) => {
                                                                            return <li key={index}><Link to={`/industries${list?.link}`} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="mega-menu-content">
                                                                <div className="mega-column">
                                                                    <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuServices?.menuSolution?.mainHeading}</h4>
                                                                    <ul className='mega-menu-main-list'>
                                                                        {megaMenuUpdatedContent?.menuServices?.menuSolution?.pageList?.map((list, index) => {
                                                                            return <li key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button mobile-mega-menu-link collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                                {megaMenuUpdatedContent?.menuEngeniers?.mainNavHeading}
                                            </button>
                                        </h2>
                                        <div id="flush-collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                            <div className="accordion-body">
                                                <div className="container">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="mega-menu-content">
                                                                <div className="mega-column">
                                                                    <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuEngeniers?.aiEngeniersList?.mainHeading}</h4>
                                                                    <ul className='mega-menu-main-list'>
                                                                        {megaMenuUpdatedContent?.menuEngeniers?.aiEngeniersList?.pageList?.map((list, index) => {
                                                                            return <li className='' key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="mega-menu-content">
                                                                <div className="mega-column">
                                                                    <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuEngeniers?.mernEngeniersList?.mainHeading}</h4>
                                                                    <ul className='mega-menu-main-list'>
                                                                        {megaMenuUpdatedContent?.menuEngeniers?.mernEngeniersList?.pageList?.map((list, index) => {
                                                                            return <li key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="mega-menu-content">
                                                                <div className="mega-column">
                                                                    <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuEngeniers?.mobileEngeniersList?.mainHeading}</h4>
                                                                    <ul className='mega-menu-main-list'>
                                                                        {megaMenuUpdatedContent?.menuEngeniers?.mobileEngeniersList?.pageList?.map((list, index) => {
                                                                            return <li key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="mega-menu-content">
                                                                <div className="mega-column">
                                                                    <h4 className="mega-menu-main-heading">{megaMenuUpdatedContent?.menuEngeniers?.webApplicationsEngeniersList?.mainHeading}</h4>
                                                                    <ul className='mega-menu-main-list'>
                                                                        {megaMenuUpdatedContent?.menuEngeniers?.webApplicationsEngeniersList?.pageList?.map((list, index) => {
                                                                            return <li key={index}><Link to={list?.link} className="mega-link">{list?.text}<i class="fa-sharp fa-solid fa-arrow-right-long"></i></Link></li>
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* <div className="col-md-12">
                                                            <div className="menu-case-study-card">
                                                                <div className="case-study-logo">
                                                                    <img src="/images/case-studies/google.png" alt="" />
                                                                </div>

                                                                <div className="case-study-content">
                                                                    <p>Discover how we collaborated with Google to deliver innovative digital solutions that drive measurable impact.</p>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <ul className='mobile-mega-menu-list'>
                                        <li><Link to='/case-studies' className="nav-link mega-menu-links">{megaMenuUpdatedContent?.caseStudiesHeading}</Link></li>
                                        {megaMenuUpdatedContent?.menuBarBox?.pageList?.map((list, index) => {
                                            return <li key={index}><Link to={list?.link} className="nav-link mega-menu-links">{list?.text}</Link></li>
                                        })}
                                        <li className="">
                                            <Button text="Book a meeting" hideIcon={true} link='https://calendly.com/bitsclan-it/30min' />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav >
        </>
    )
}

export default MegaMenu